import React from 'react'
import UserHero from './partials/UserHero'
import UserAccount from './partials/UserAccount'
import ListGroup from './partials/ListGroup'
import UserBooking from './partials/UserBooking'
import { Link } from 'react-router-dom'

export default function UserOfferPage() {
  return (
    <>
    <UserHero />
          <div className="container">
            <UserAccount />
            <div className="row">
              <ListGroup />
              <div className="col-md-8 col-sm-6 col-12">
                 <div className="user-offer-h2">
                        <h2>OFFERS</h2>
                 </div>
                 <div className="offer-div">
                    <div className="offer-img">
                            <img src="images/home/DRINK.jpg" alt="" />
                    </div>
                    <div className="offer-card-right">
                    <div className="offer-p">
                        <p>25% Saving on Breakfast Stays</p>
                    </div>
                    <div className="offer-p1">
                        <p>Daily Breakfast at designated Dining Stay</p>
                    </div>
                    <div className="offer-h4">
                        <h4>Classic Room the Rains</h4>
                    </div>
                    <div className="offer-para">
                        <p>Good hotel the v grand shoba Lorem ipsum dolor, sit amet consectetur adipisicing elit. Placeat, adipisci.</p>
                    </div>
                    <div className="offer-date">
                        <p>VALID UNTIL : <strong> 15 may 2025</strong> </p>
                    </div>
                    <hr />
                <div className="offer-page-btn">
                <Link  >
                <button>BOOK NOW</button>
                </Link>    
                </div>
                    </div>
                    
                    
               
                 </div>

                 <div className="offer-div">
                    <div className="offer-img">
                            <img src="images/home/DRINK.jpg" alt="" />
                    </div>
                    <div className="offer-card-right">
                    <div className="offer-p">
                        <p>25% Saving on Breakfast Stays</p>
                    </div>
                    <div className="offer-p1">
                        <p>Daily Breakfast at designated Dining Stay</p>
                    </div>
                    <div className="offer-h4">
                        <h4>Classic Room the Rains</h4>
                    </div>
                    <div className="offer-para">
                        <p>Good hotel the v grand shoba Lorem ipsum dolor, sit amet consectetur adipisicing elit. Placeat, adipisci.</p>
                    </div>
                    <div className="offer-date">
                        <p>VALID UNTIL : <strong> 15 may 2025</strong> </p>
                    </div>
                    <hr />
                <div className="offer-page-btn">
                <Link  >
                <button>BOOK NOW</button>
                </Link>    
                </div>
                    </div>
                    
                    
               
                 </div>

                 
              </div>
              
            </div>
          </div>
    </>
  )
}
